import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogTitle from '@mui/material/DialogTitle';
import { cancelInvoices } from 'src/shared/services/invoiceService';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import { useGlobals } from 'src/shared/contexts/appContext';
import { useIsMounted } from 'src/shared/hooks/useIsMounted';

type CancelMultipleInvoicesDialogProps = {
  invoiceIds: number[];
  showDialog: boolean;
  callback: () => void;
  onCancel: () => void;
};

export const CancelMultipleInvoicesDialog = (props: CancelMultipleInvoicesDialogProps) => {
  const { invoiceIds, showDialog, callback, onCancel } = props;
  const { setDateStamp } = useGlobals();

  const isMounted = useIsMounted();

  const { t } = useTranslation(['common', 'invoice']);

  const handleClose = () => {
    setDateStamp(new Date());
    callback();
  };

  const handleCancel = async () => {
    try {
      await cancelInvoices(invoiceIds);
      if (isMounted()) {
        toast.success(<>{t('invoice:CancelInvoicesSuccess')}</>);
        setDateStamp(new Date());
        callback();
        onCancel();
      }
    } catch (e) {
      if (isMounted()) {
        toast.error(<>{t('invoice:CancelInvoicesError')}</>);
        callback();
      }
    }
  };

  return (
    <div>
      <Dialog open={showDialog} onClose={handleClose} aria-labelledby='alert-dialog-title'>
        <DialogTitle id='alert-dialog-title'>{t('invoice:CancelInvoicesPromt')}</DialogTitle>
        <DialogActions>
          <Button onClick={handleClose}>{t('common:button.cancel')}</Button>
          <Button onClick={handleCancel} autoFocus>
            {t('invoice:Cancel')}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};
